import {Image} from '@app/components/Image';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';
import {ListItem, UnorderedList} from '@tempo/core';
import {LandingHeading} from '@tempo/landing';
import {useTranslation} from '@app/hooks/use-translation';
import type {FunctionComponent} from 'react';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

const IMAGE_CONFIG: LocalImageConfig = {
	default: 'c15571d278efafc80fc68ea5850bcf70.png',
	fr: '5e0e39780f91a02e4710975b7392280c.png',
};

export const SongcatcherTap: FunctionComponent = () => {
	const {t} = useTranslation();
	const src = useLocalImage(IMAGE_CONFIG);
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'songcatcherlandingpage_title_songcatcherisjustatapaway_standalone-web',
							{ns: 'songcatcher'},
						)}
					</LandingHeading>
					<UnorderedList
						display="flex"
						flexDirection="column"
						color="text.neutral.secondary.default"
						w={{base: '90%', md: '100%'}}
						textAlign={{base: 'start', md: 'center'}}
						alignItems={{base: 'start', md: 'center'}}
					>
						<ListItem
							dangerouslySetInnerHTML={{
								__html: t(
									'songcatcherlandingpage_text_songcatcherisjustatapaway1_standalone-web',
									{
										ns: 'songcatcher',
									},
								),
							}}
						></ListItem>
						<ListItem
							dangerouslySetInnerHTML={{
								__html: t(
									'songcatcherlandingpage_text_songcatcherisjustatapaway2_standalone-web',
									{
										ns: 'songcatcher',
									},
								),
							}}
						></ListItem>
						<ListItem
							dangerouslySetInnerHTML={{
								__html: t(
									'songcatcherlandingpage_text_songcatcherisjustatapaway3_standalone-web',
									{
										ns: 'songcatcher',
									},
								),
							}}
						></ListItem>
					</UnorderedList>
				</>
			}
			image={
				<Image
					src={src}
					aspectRatio="7200/2100"
					alt={t('metatag_text_songcatcherintelligence_standalone-web', {
						ns: 'common',
					})}
				/>
			}
		/>
	);
};
